import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const VerificationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const hasManualUnlock = (soid, key) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(
      `${BASE_URL}/identity-verification/soid/${soid}/key/${key}`,
      {
        headers,
      }
    );
  };

  const createManualUnlock = (soid, key, durationHours) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/identity-verification/soid/${soid}/key/${key}/durationHours/${durationHours}`,
      {},
      {
        headers,
      }
    );
  };

  service.hasManualUnlock = hasManualUnlock;
  service.createManualUnlock = createManualUnlock;

  return service;
})();

export default VerificationService;
